import { getAudienceUrl } from "../audience";
import { Audience } from "../../types/audience";

/**
 * Generates a fully-qualified URL given which portal and parts of the URL.
 * This is not necessary for Next.js links between pages of the same portal.
 */
export const getExternalSlugUrl = (portal: Audience, ...slugParts: string[]) =>
  getAudienceUrl(portal) + getUriFromSlugParts(...slugParts);

/**
 * Generates a fully-qualified URI (starts with forward slash) given parts of
 * a URL by joining parts with slashes. Use for internal/Next.js links within
 * the same portal.
 */
export const getUriFromSlugParts = (...slugParts: string[]) => "/" + slugParts.join("/");

/**
 * Generate a slug (letters and numbers separated by dashes) given an unsafe
 * text string that can contain any characters.
 */
export const generateSlugFromText = (text: string): string =>
  text
    .trim()
    .toLowerCase()
    // Convert underscores to dashes
    .replace(/_/g, "-")
    // Strip out everything but letters, numbers, spaces, and dashes
    .replace(/[^a-z0-9 \-]+/g, "")
    // Replace all spaces with dashes
    .replace(/ +/g, "-")
    // Replace consecutive dashes with a single dash
    .replace(/-{2,}/g, "-");
